
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/tebra",
      function () {
        return require("private-next-pages/customers/tebra.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers/tebra"])
      });
    }
  